<template>
  <div class="mt-2">
    <ul
      role="list"
      class="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8"
    >
      <li
        v-for="file in files"
        :key="file.id"
        class="relative media-item"
      >
        <div
          class="group block w-full aspect-w-10 aspect-h-7 rounded-lg bg-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-400 focus-within:ring-indigo-500 overflow-hidden"
        >
          <img
            :src="getImagePreviewUrl(file)"
            alt=""
            class="object-cover pointer-events-none group-hover:opacity-75"
          />
          <button
            type="button"
            class="absolute inset-0 focus:outline-none"
          >
            <span class="sr-only"> View details for file </span>
          </button>
        </div>

        <span
          v-if="file.featured"
          class="text-red-400"
          >FEATURED</span
        >

        <p class="mt-2 block text-sm font-bold font-medium text-gray-900 truncate pointer-events-none">
          {{ file.name || '' }}
        </p>

        <p class="mt-1 block text-xs italic font-medium text-gray-900 truncate pointer-events-none">
          {{ file.mime || '' }}
        </p>

        <confirm-featured
          v-if="!file.featured"
          :src="getFeaturedRoute(file)"
          :file="file"
        />
        <confirm-delete
          :src="getDeleteRoute(file)"
          :file="file"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import ConfirmDelete from '@/Components/Media/ConfirmDelete'
import ConfirmFeatured from '@/Components/Media/ConfirmFeatured'

export default {
  components: { ConfirmDelete, ConfirmFeatured },
  props: {
    /**
     * An array of files to display
     */
    files: {
      type: Array,
      default() {
        return []
      }
    },

    /**
     * The URL to send a delete request to. If parent does not provide this prop the function will return null. If
     * this function returns null we don't show the delete button
     */
    destroy: {
      type: Function,
      default: (file) => null
    },

    /**
     * The URL to send a "set as featured" request to. If parent does not provide this prop the function will
     * return null. If this function returns null we don't show the "make featured" button
     */
    featured: {
      type: Function,
      default: (file) => null
    }
  },

  methods: {
    /**
     * Returns the URL we can use to display a preview for this file
     * @param image
     * @returns {string|*}
     */
    getImagePreviewUrl(image) {
      if (image.sizes && image.sizes.thumb) {
        return image.sizes.thumb
      }

      return image.url
    },

    /**
     * Determines the correct route to use to delete a file. Requires a function be passed in via the router prop
     * and if one has not been provided, this function will just return null. The delete modal component will not
     * display if this function returns null.
     * @param file
     * @returns String | null
     */
    getDeleteRoute(file) {
      return this.destroy(file)
    },

    /**
     * Determines the correct route to set a file as the "featured image". Requires a function be passed in via the
     * router prop and if one has not been provided, this function will just return null. The delete modal
     * component will not display if this function returns null.
     * @param file
     * @returns String | null
     */
    getFeaturedRoute(file) {
      return this.featured(file)
    }
  }
}
</script>
